module.exports = "/_next/static/images/SynthesizeImage@2x-72602f8727ab6d18b96f2096b92928af.png";